// extracted by mini-css-extract-plugin
export default {"emptyStateBox":"EmptyStateBox_emptyStateBox__Nussf","emptyStateText":"EmptyStateBox_emptyStateText__Xr5W-","emptyStateImg":"EmptyStateBox_emptyStateImg__pKR7a"};